/* eslint-disable */
/*********************************************************
/ Glorious generated code by DoneDone's Code Generator.
/ Written by Ka Wai Cheung.
/ Don't modify this by hand silly!
*********************************************************/

import { RequestHandler } from '../request-handler'
import {
  IAccountMembershipsInputCreateFromZapier,
  IAccountMembershipsInputCreate,
  IAccountMembershipsInputInviteToProject,
} from '../types/request.types'
import {
  IAccountMembershipsOutputDetail,
  IAccountMembershipsOutputUpdateOptions,
  IPersonWithEmail,
  IAccountMembershipsOutputCreateOptions,
  IAccountMembershipsOutputInviteCoworkersResult,
  IGenericJSONMessage,
  ILimitCheck,
} from '../types/response.types'

export default new class AccountMembershipsAPI extends RequestHandler {
  /****** GET methods *****/
  public async get_Detail(
    account_membership_id: any,
  ): Promise<IAccountMembershipsOutputDetail> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/account-memberships/${account_membership_id}`,
    })
  }
  public async get_UpdateOptions(
  ): Promise<IAccountMembershipsOutputUpdateOptions> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/account-memberships/update-options`,
    })
  }
  public async get_ReassignmentOptions(
    account_membership_id: any,
  ): Promise<IPersonWithEmail[]> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/account-memberships/${account_membership_id}/reassignment-options`,
    })
  }
  public async get_CreateOptions(
  ): Promise<IAccountMembershipsOutputCreateOptions> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/account-memberships/create-options`,
    })
  }
  public async get_SendSignInEmail(
    account_membership_id: any,
  ): Promise<IGenericJSONMessage> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/account-memberships/${account_membership_id}/send-sign-in-email`,
    })
  }
  public async get_LimitCheck(
  ): Promise<ILimitCheck> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/account-memberships/limit-check`,
    })
  }
  /****** POST methods *****/
  public async post_CreateFromZapier(
    data: IAccountMembershipsInputCreateFromZapier,
  ): Promise<IGenericJSONMessage> {
    return await this.post({
      url: `/[[ACCOUNT_ID]]/companies/account-memberships/from-zapier`,
      data,
    })
  }
  public async post_Create(
    data: IAccountMembershipsInputCreate,
  ): Promise<IGenericJSONMessage> {
    return await this.post({
      url: `/[[ACCOUNT_ID]]/account-memberships`,
      data,
    })
  }
  public async post_InviteCoworkers(
    listEmailAddresses: string[],
  ): Promise<IAccountMembershipsOutputInviteCoworkersResult> {
    return await this.post({
      url: `/[[ACCOUNT_ID]]/account-memberships/invite-coworkers`,
      data: {
        listEmailAddresses
      },
    })
  }
  public async post_InviteToProject(
    data: IAccountMembershipsInputInviteToProject,
  ): Promise<IGenericJSONMessage> {
    return await this.post({
      url: `/[[ACCOUNT_ID]]/account-memberships/invite-to-project`,
      data,
    })
  }
  public async post_Delete(
    account_membership_id: any,
    userIDToReassignItemsTo: number,
  ): Promise<IGenericJSONMessage> {
    return await this.post({
      url: `/[[ACCOUNT_ID]]/account-memberships/${account_membership_id}/delete`,
      data: {
        userIDToReassignItemsTo
      },
    })
  }
  /****** PUT methods *****/
  public async put_UpdateRole(
    account_membership_id: any,
    accountRoleID: number,
  ): Promise<IGenericJSONMessage> {
    return await this.put({
      url: `/[[ACCOUNT_ID]]/account-memberships/${account_membership_id}/role`,
      data: {
        accountRoleID
      },
    })
  }
  public async put_UpdateCompany(
    account_membership_id: any,
    companyID: number,
  ): Promise<IGenericJSONMessage> {
    return await this.put({
      url: `/[[ACCOUNT_ID]]/account-memberships/${account_membership_id}/company`,
      data: {
        companyID
      },
    })
  }
  public async put_UpdateProjectMemberships(
    account_membership_id: any,
    listProjectIDs: number[],
  ): Promise<IGenericJSONMessage> {
    return await this.put({
      url: `/[[ACCOUNT_ID]]/account-memberships/${account_membership_id}/projects`,
      data: {
        listProjectIDs
      },
    })
  }
}()
